import Vue from 'vue'
import VueRouter from 'vue-router'
import TestSelection from '../components/TestSelection.vue'
import Questionnaire from '../components/Questionnaire.vue'
import QuestionnaireResult from '../components/QuestionnaireResult.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: TestSelection
  },
  {
    path: '/twelve-test',
    name: 'TwelveTest',
    component: Questionnaire
  },
  {
    path: '/result',
    name: 'Result',
    component: QuestionnaireResult
  }
  // MBTI测试路由可以后续添加
]

const router = new VueRouter({
  routes
})

export default router
